import { ELEMENT_DEFAULTS } from "../constants/quotationConstants";

let idCounter = 1;
export const newId = () => `el${idCounter++}`;

export function rowHeightFor(el) {
  return Math.round((el.fontSize || 12) + 20);
}

export function rehydrateElements(rawElements) {
  return (rawElements || []).map((el) => ({ ...el, id: newId() }));
}

export function makeElement(type, x, y) {
  return { id: newId(), type, x, y, ...ELEMENT_DEFAULTS[type]() };
}

// ============ script loader for html2canvas + jsPDF ============
export function loadScriptOnce(src, globalCheck) {
  return new Promise((resolve, reject) => {
    if (globalCheck()) return resolve();
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("Failed to load " + src)));
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load " + src));
    document.head.appendChild(script);
  });
}

export async function ensurePdfLibs() {
  await loadScriptOnce(
    "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js",
    () => !!window.html2canvas
  );
  await loadScriptOnce(
    "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js",
    () => !!(window.jspdf && window.jspdf.jsPDF)
  );
}
